import {API_URL, clientAxios} from '../../shared/clientHttp';
import {checkSignal, requestJSON, safeMediaURL} from '../../home_media_ui/direct';

// Only a relative, application-scoped API request receives the login token.
// The resulting short capability is read anonymously; stored FileField URLs
// are never followed or trusted as API endpoints.
export async function applicationAttachmentAccess(applicationId, node, preview, signal) {
  checkSignal(signal);
  const token = localStorage.getItem('client_token');
  if (!token) throw new Error('Войдите в кабинет, чтобы открыть файл.');
  const body = {...(node.plan ? {plan: true} : {file_id: node.fileId}), preview};
  const response = await clientAxios.post(
    `/main/api/client/applications/${encodeURIComponent(applicationId)}/media-access/`, body,
    {signal, timeout: 30000});
  checkSignal(signal);
  if (localStorage.getItem('client_token') !== token) throw new DOMException('Cancelled', 'AbortError');
  const result = response.data;
  const ticket = safeMediaURL(result?.url);
  const api = new URL(API_URL);
  if (ticket.origin !== api.origin || ticket.pathname !== '/main/api/client/application-media-content/') {
    throw new Error('Не удалось получить ссылку на файл. Повторите попытку.');
  }
  // Resolve the broker without cross-origin redirects so anonymous image CORS
  // stays intact. It rechecks revocation and retained bytes before returning.
  ticket.searchParams.set('resolve', '1');
  const resolved = await requestJSON(ticket.href, {cache: 'no-store'}, signal);
  checkSignal(signal);
  if (localStorage.getItem('client_token') !== token) throw new DOMException('Cancelled', 'AbortError');
  return {...result, url: safeMediaURL(resolved?.url).href};
}

export function downloadApplicationAttachment(url) {
  const anchor = document.createElement('a');
  anchor.href = safeMediaURL(url).href;
  anchor.rel = 'noreferrer noopener';
  anchor.referrerPolicy = 'no-referrer';
  // Content-Disposition is set by the broker/home token. No large Blob and no
  // new tab are needed, including PDF, DWG and other document formats.
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
}
